import React from 'react';
import styled from 'styled-components/macro';
import { Span, Paragraph } from '../../../../components/typography';
import { Col } from '../../../../components/grid';
import ErrorText from './DeliveryErrorText';
import { ScreenSizeDetector } from '../../../../lib/helpers';
import { BsCheckSquare, BsSquare, FaExclamationTriangle } from '../../../../components/Icons';

const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 5px;

  & > svg {
    font-size: 20px;
    fill: ${({ theme, grey, green }) => {
      if (grey) {
        return theme.colors.colorGrey;
      }
      if (green) {
        return theme.colors.colorGreen;
      }
      return theme.colors.colorGreyDark;
    }};
  }
`;
const Header = styled(({ children, ...props }) => <div {...props}>{children}</div>)`
  margin: -15px -15px 10px -15px;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 15px;
  background: ${({ theme }) => theme.colors.colorGreyLight};
  ${({ choosen, error, theme }) => {
    if (choosen && !error) {
      return `
        background-color: ${theme.colors.colorGreenHighlight};
      `;
    }
    return `
    `;
  }}
`;
const DeliveryOptionWrapNoStyle = ({
  children,
  error,
  choosen,
  ...otherProps
}) => (
  <div {...otherProps}>
    {children}
  </div>
);
const DeliveryOptionWrap = styled(DeliveryOptionWrapNoStyle)` 
  position: relative; 
  ${({ error, choosen }) => {
    if (error && !choosen) {
      return 'cursor: no-drop;';
    }
    if (choosen) {
      return '';
    }
    return `
      cursor: pointer;
    `;
  }}
  ${({ choosen, error, theme }) => {
    if (choosen && !error) {
      return `
        //border: 5px solid ${theme.colors.colorGreen};
      `;
    } if (!choosen && error) {
      return `
        background-color: ${theme.colors.colorGreyLight};
        color: ${theme.colors.colorGrey};
      `;
    } if (choosen && error) {
      return 'border: 5px solid red;';
    }
    return `
      background-color:  ${theme.colors.colorWhite};
    `;
  }}

  &:after {
    ${({ choosen }) => {
      if (!choosen) {
        return `
        content: "";
        display: block;
        width: 100%;
        height: 110px;
        position: absolute;
        top: 30px;
        background: linear-gradient(0deg,rgba(255,255,255,1) 10%,rgba(0,0,0,0) 100%);
        `;
      }
      return `
            
      `;
    }}
  }
`;
const ErrorTextWrapNoStyle = ({
  children,
  error,
  choosen,
  ...otherProps
}) => (
  <Paragraph italic {...otherProps}>
    {children}
  </Paragraph>
);
const ErrorTextWrap = styled(ErrorTextWrapNoStyle)`
  ${({ choosen, error, theme }) => {
    if (choosen && error) {
      return `
        color: ${theme.colors.colorRed};
      `;
    }
    return '';
  }}
`;
export default ({
  choosen,
  onChoose,
  error,
  headline,
  children,
  className,
  subheadline,
}) => {
  let theIcon = error
    ? (
      <StyledIcon><FaExclamationTriangle /></StyledIcon>
    )
    : <StyledIcon green><BsCheckSquare /></StyledIcon>;
  if (!choosen) {
    if (error) {
      theIcon = (
        <StyledIcon grey><FaExclamationTriangle /></StyledIcon>
      );
    } else {
      theIcon = <StyledIcon><BsSquare /></StyledIcon>;
    }
  }
  return (
    <DeliveryOptionWrap
      role={(choosen || error) ? undefined : 'button'}
      onClick={(choosen || error) ? undefined : onChoose}
      choosen={choosen}
      error={Boolean(error)}
      className={className}
    >
      <Col xs={12} padding="15px 15px 0 15px">
        <Header
          choosen={choosen}
          error={error}
          onClick={(choosen || error) ? undefined : onChoose}
        >
          {theIcon}
          <div>
            <Span fontSize="16px" bold relative>{headline}</Span>
            {subheadline && (
              <ScreenSizeDetector block={[true]} marginTop={['4px']}>
                <Span fontSize="12px" relative>{subheadline}</Span>
              </ScreenSizeDetector>
            )}
            {error && <ErrorTextWrap choosen={choosen} error={error}><ErrorText error={error} /></ErrorTextWrap>}
          </div>
        </Header>
        {children}
      </Col>
    </DeliveryOptionWrap>
  );
};
